import { makeStyles } from 'tss-react/mui';

import { brandColors } from '@/styles/theme/values/brandColors';

const CARD_MAX_WIDTH = 416;
const CARD_GAP_LG = 64;
const CARD_GAP = 40;

const useStyles = makeStyles({
  name: 'ActionCards',
})(({ spacing, breakpoints, typography }) => ({
  container: {
    '&.OnLight': {
      backgroundColor: brandColors.tintsOffWhite60,
    },
    '&.OnDark': {
      backgroundColor: brandColors.tintsHeroBlue10,
    },
  },
  cardContainer: {
    marginTop: spacing(3),
    display: 'grid',
    gap: spacing(3),
  },
  cardContainer2: {
    gridTemplateColumns: '1fr',
    [breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      maxWidth: typography.pxToRem(2 * CARD_MAX_WIDTH + CARD_GAP),
    },
    [breakpoints.up('lg')]: {
      maxWidth: typography.pxToRem(2 * CARD_MAX_WIDTH + CARD_GAP_LG),
    },
  },
  cardContainer3: {
    gridTemplateColumns: '1fr',
    [breakpoints.up('sm')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      maxWidth: typography.pxToRem(2 * CARD_MAX_WIDTH + CARD_GAP),
    },
    [breakpoints.up('md')]: {
      gridTemplateColumns: 'repeat(3, 1fr)',
      maxWidth: typography.pxToRem(3 * CARD_MAX_WIDTH + 2 * CARD_GAP),
    },
    [breakpoints.up('lg')]: {
      maxWidth: typography.pxToRem(3 * CARD_MAX_WIDTH + 2 * CARD_GAP_LG),
    },
  },
  card: {
    borderRadius: typography.pxToRem(16),
    padding: spacing(2),
    maxWidth: typography.pxToRem(416),
    '&.OnLight': {
      backgroundColor: brandColors.primaryMain,
      '& .primaryTextColor': {
        color: 'white',
      },
      '& .accentTextColor': {
        color: brandColors.tintsOffWhite40,
      },
    },
    '&.OnDark': {
      backgroundColor: brandColors.offWhite,
      '& .accentTextColor': {
        color: brandColors.tintsNeutral20,
      },
    },
  },
  cardContent: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  cardHeading: {
    marginTop: spacing(0),
  },
  cardSubheading: {
    marginTop: spacing(0),
  },
  cardCta: {
    marginTop: spacing(2),
  },
  icon: {
    margin: spacing(-1),
  },
}));

export default useStyles;
